import { useEffect, useState } from 'react';
import { FilterItem, PicklistItem } from '../types/filters';
import { filterKeys } from '../enums/filter-key';
import { centsClient } from '../api/cents/clients/cents-client';
import { Contract } from '../types/contract';
import { AppDispatch, RootState } from '../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { removeFilter as remove, updateFilters as update, removeAllFilters as removeAll } from '../redux/slices/session';
import { translations } from '../utils/translations/translations-manager';



const useFilters = () => {
  const dispatch: AppDispatch = useDispatch()
  const activeFilters = useSelector((state: RootState) => state.auth.activeFilters) || {}

  const getActiveFilters = (): Record<string, any> => {
    return activeFilters
  }

  const addFilter = (key: string, value: any) => {
    dispatch(update({ [key]: value }))
  }

  const removeFilter = (key: string) => {
    dispatch(remove(key))
  }

  const removeAllFilters = () => {
    dispatch(removeAll())
    // TODO: implement resetFilters
  }

  const mapKeysToFilters = (): FilterItem[] => {
    const filterLabels: Record<filterKeys, string> = {
      [filterKeys.contractId]: translations.texts.contract_id.toString(),
      [filterKeys.fullName]: translations.texts.name_and_surname.toString(),
      [filterKeys.campaignId]: translations.texts.campaign.toString(),
      [filterKeys.startAmount]: translations.texts.start_amount.toString(),
      [filterKeys.endAmount]: translations.texts.end_amount.toString(),
      [filterKeys.type]: translations.texts.type.toString(),
      [filterKeys.status]: translations.texts.status.toString(),
      [filterKeys.operatorId]: translations.texts.operator_code.toString(),
      [filterKeys.paymentType]: translations.texts.payment_method.toString(),
      [filterKeys.startDate]: translations.texts.start_date.toString(),
      [filterKeys.endDate]: translations.texts.end_date.toString(),
      [filterKeys.fullText]: translations.texts.search.toString()
    };

    return Object.entries(filterLabels).map(([key, label]) => ({
      id: key,
      label,
      value: null,
    }))
  }

  const getFilterItem = (key: string): FilterItem => {
    const filterItems = mapKeysToFilters()
    return filterItems.find(filter => filter.id === key) || {}
  }

  const getValueLabel = (picks: PicklistItem[], key: string): string => {
    return picks.find(pick => pick.id === key)?.label() ?? ''
  }

  return { getActiveFilters, addFilter, removeAllFilters, removeFilter, getFilterItem, getValueLabel }
}

export default useFilters;
